import React from 'react';

export interface TableProps {
  children: React.ReactNode;
  className?: string;
}

export const Table: React.FC<TableProps> = ({ children, className = '' }) => {
  return (
    <div className="overflow-x-auto">
      <table className={`min-w-full divide-y divide-gray-200 ${className}`}>
        {children}
      </table>
    </div>
  );
};

export const TableHead: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <thead className="bg-gray-50">{children}</thead>;
};

export const TableBody: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <tbody className="bg-white divide-y divide-gray-200">{children}</tbody>;
};

export interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const TableRow: React.FC<TableRowProps> = ({
  children,
  className = '',
  onClick,
  ...rest
}) => {
  return (
    <tr className={className} onClick={onClick} {...rest}>
      {children}
    </tr>
  );
};

export const TableHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => {
  return (
    <th
      scope="col"
      className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${className}`}
    >
      {children}
    </th>
  );
};

export const TableCell: React.FC<{
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}> = ({
  children,
  className = '',
  onClick,
}) => {
  const trimmed = className.trim();
  const hasCustomPadding = /\b(p-?|px-|py-|pt-|pb-|pl-|pr-)\S*/.test(trimmed);
  const paddingClasses = hasCustomPadding ? '' : 'px-6 py-4';

  return (
    <td
      className={`${paddingClasses} whitespace-nowrap text-sm text-gray-900 ${trimmed}`}
      onClick={onClick}
    >
      {children}
    </td>
  );
};
